import { EnvironmentVariable, defaultVariables } from "../config/env";
import viteEnv from "../config/viteenv";

type Environment = "next" | "tauri" | "browser";

let executing: Environment;
let _env: (name: keyof EnvironmentVariable) => string;

/////////////////////////////////////
//////////////////////////////////////

//////////////////////

////////////////////////////////////////////////////

//////////
// #v-endif

//////////////////////////////////
// #v-ifdef VITE_ENVIRONMENT='next'

executing = "next";

_env = (name: string) => {
	return process.env[name];
};

// #v-endif
//////////

//////////////////////////////////
///////////////////////////////////

///////////////////

//////////////////////////
//////////////////////////
//

///////////
//////////

///////////////////////////////////
////////////////////////////////////

////////////////////

//////////////////////////
////////////////////////////////////
//

////////////
//////////

const builtIn = { ...(process as any).builtIn, ...viteEnv };

export const env = <T extends keyof EnvironmentVariable>(name: T): EnvironmentVariable[T] =>
	builtIn?.[name] ?? _env(name) ?? defaultVariables[name];

export const getExecutingEnvironment = (): Environment => executing;
